import { Container } from './Container'
import { getBreakpoint } from '../styles/getBreakpoint'

export const AuthContainer = Container.extend`
  ${getBreakpoint(0)`
		border: 1px solid #ddd;
		border-radius: 4px;
		margin-top: 48px;
		width: ${7 / 12 * 100}%;
	`} ${getBreakpoint(1)`
		width: ${5 / 12 * 100}%;
	`};
`



// WEBPACK FOOTER //
// ./src/components/AuthContainer.tsx